module.exports = require("@material-ui/icons/AddAPhoto");